import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/app/node_modules/react-error-boundary/dist/react-error-boundary.js");
;
import(/* webpackMode: "eager" */ "/app/public/next-public/common/icons/caret-regular-left.svg");
;
import(/* webpackMode: "eager" */ "/app/public/next-public/common/icons/caret-solid-right.svg");
;
import(/* webpackMode: "eager" */ "/app/public/next-public/common/icons/quality-shield.svg");
;
import(/* webpackMode: "eager" */ "/app/public/next-public/common/icons/recommended-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/next-public/common/icons/verified-buyer-icon.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/banners/productPageBannerAd.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/ec/product/[basePath]/assuredQuality.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/ec/product/[basePath]/boughtThisMonth.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/ec/product/[basePath]/customer-reviews/nettieReviewSummary.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/ec/product/[basePath]/customer-reviews/reviewHelpfulness.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/ec/product/[basePath]/customer-reviews/reviewList.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/ec/product/[basePath]/customer-reviews/reviewSummary.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/ec/product/[basePath]/customer-reviews/customerReviews.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/ec/product/[basePath]/manufacturer-promotions/productDetailPagePromotionTagBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/ec/product/[basePath]/outOfStock.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/ec/product/[basePath]/productAttributes.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/ec/product/[basePath]/productGTMLoad.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/ec/product/[basePath]/productInformation.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/ec/product/[basePath]/productKeyFeatures.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/ec/product/[basePath]/productMedia.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PurchaseHistory"] */ "/app/src/app/ec/product/[basePath]/purchase-history/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/ec/product/[basePath]/returnGuarantee.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/ec/product/[basePath]/reviewsSummary.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/ec/product/[basePath]/setLocalStorageComp.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/ec/product/[basePath]/valuePropositions.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/ec/product/[basePath]/productDetailPage.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/ec/product/[basePath]/vendor-options/productDetailClientPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/ec/product/[basePath]/yotpoQuestion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/ec/product/recommendations/algoliaProductRecommendationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/ec/product/recommendations/algoliaSidebarRecommendationsSection .tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/errors/unknownError.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/review/products/reviewGiveawayBanner.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/design-system/alert/alert.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/design-system/breadcrumbs/breadcrumbs.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/design-system/button/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/design-system/checkmark/checkmark.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/design-system/star-rating/starRating.tsx");
